import { render, staticRenderFns } from "./ReservierungSelectVorbestellung.vue?vue&type=template&id=c431b772"
import script from "./ReservierungSelectVorbestellung.vue?vue&type=script&lang=ts"
export * from "./ReservierungSelectVorbestellung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports